export const copyToClipboard = (value: any) => {
  const body = document.body
  const tmpInput = document.createElement('INPUT') as any
  body.appendChild(tmpInput)
  tmpInput.setAttribute('value', value)
  tmpInput.select()
  document.execCommand('copy')
  body.removeChild(tmpInput)
}
